var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z",
    stroke: "#80E614",
    fill: "#80E614"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7h-2v6h6v-2h-4z",
    stroke: "#80E614",
    fill: "#80E614"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxTime);
export default __webpack_public_path__ + "static/media/bx-time.54a4c3e2061eb1ab2138ba574b9850af.svg";
export { ForwardRef as ReactComponent };